import { useNavigate } from 'react-router-dom';
import { usePartner } from '../contexts/PartnerContext';



export const usePartnerNavigation = () => {
  
  const navigate = useNavigate();
  const { currentSubdomain, isDevMode, isWhiteLabel } = usePartner();

  const addPartnerParam = (path) => {
    if (!isDevMode || !isWhiteLabel || !currentSubdomain) {
      return path;
    }
    
    // Handle paths that already have parameters
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}partner=${currentSubdomain}`;
  };

  const navigateWithPartner = (path, options = {}) => {
    const finalPath = addPartnerParam(path);
    navigate(finalPath, options);
  };

  const createLinkProps = (to, otherProps = {}) => {
    return {
      to: addPartnerParam(to),
      ...otherProps
    };
  };

  const generatePartnerUrl = (path) => {
    return addPartnerParam(path);
  };

  return {
    navigate: navigateWithPartner,
    addPartnerParam,
    createLinkProps,
    generatePartnerUrl,
    originalNavigate: navigate
  };
};

export default usePartnerNavigation;